import * as THREE from 'three';
import jQuery from 'jquery';
const $ = jQuery;
const languageOptions = '/assets/UI/langSprite-min.png';
const appBox = '/assets/UI/Main-Popup.png';
import * as QRCode from 'qrcode';

const twistOnItImg = '/assets/UI/sprite_sheet-min.png';
const scannerArea = '/assets/UI/Popup.png';
const TopStrip = '/assets/UI/Top-Strip.png';
const mobileSprite = '/assets/UI/mobileSprite.png';
const handsprite = '/assets/UI/handsprite.png';
const timeSprite = '/assets/UI/timeSprite.png';

const SpriteAnimENG = '/assets/UI/sprite_sheet-min.png';
const SpriteAnimARB = '/assets/UI/sprite_sheet-minARB.png';

const joinENG = '/assets/UI/join.png';
const joinARB = '/assets/UI/joinARB.png';
const signupsigninENG = '/assets/UI/Sign-up-or-Sign-in.png';
const signupsigninARB = '/assets/UI/Sign-up-or-Sign-inARB.png';

const metBeforeENG = '/assets/UI/We-met-Before.png';
const metBeforeARB = '/assets/UI/We-met-BeforeARB.png';
const firstTimeENG = '/assets/UI/First-time-twisting.png';
const firstTimeARB = '/assets/UI/First-time-twistingARB.png';
const PickSideENG = '/assets/UI/Pick-your-side.png';
const PickSideARB = '/assets/UI/Pick-your-sideARB.png';

const howToPlayENG = '/assets/UI/How-to-play.png';
const howToPlayARB = '/assets/UI/How-to-playARB.png';
const youHaveChoosenENG = '/assets/UI/Youve-choosen-your-flavor-champ.png';
const youHaveChoosenARB = '/assets/UI/Youve-choosen-your-flavor-champARB.png';
const scannerTitleImgENG = '/assets/UI/Twist-battle-2-player-needed.png';
const scannerTitleImgARB = '/assets/UI/Twist-battle-2-player-neededARB.png';
const justSoWeKnowImgENG =
  '/assets/UI/Just-so-we-know-to-crown-cookie-champ.png';
const justSoWeKnowImgARB =
  '/assets/UI/Just-so-we-know-to-crown-cookie-champARB.png';

import EventDispatcher from './components/EventDispatcher';
import AssetLoader from './components/AssetLoader';
import Global from './components/Global';
import Room from './components/Room';
import './scss/style.scss';

import Header from './components/Header';
import LeaderBoard from './components/LeaderBoard';
import Home from './components/Home';
import LangSelection from './components/LangSelection';
import SignUp from './components/SignUp';
import SignIn from './components/SignIn';
import Score from './components/Score';
import PlayToWin from './components/PlayToWin';
import Error from './components/Error';
import SignupSignin from './components/SignupSignin';
import TapToTwist from './components/TapToTwist';
import SelectFlavour from './components/SelectFlavour';
import Select from './components/Select';
import SignUpToPlay from './components/SignUpToPlay';
import QRScanner from './components/QRScanner';
import GameInst from './components/GameInst';
import PlayerName from './components/PlayerName';
import Result from './components/Result';

import { hideMenu, initMenu, showMenu } from './components/menu2';
import { initLang, changeLanguage } from './components/lang';
import Instruction from './components/Instruction';
import { Server } from './callServer';
import Selection from './components/Selection';
import Camera from './components/Camera';
import Control from './components/Control';
import { isMobile, isMobileOnly } from 'mobile-device-detect';
import gsap from 'gsap';
import { initColyseus } from './components/socket';

// const isMobile = true;
export default class Game extends THREE.Scene {
  environmentMap = null;
  sizes = {
    width: window.innerWidth,
    height: window.innerHeight,
  };

  constructor() {
    super();

    window.addEventListener('resize', this.onResize.bind(this));
  }

  init() {
    document.querySelector(
      '.languageOptions'
    ).style.backgroundImage = `url(${languageOptions})`;
    document.querySelectorAll('.appContainer .box').forEach((box) => {
      box.style.backgroundImage = `url(${appBox})`;
    });
    document.querySelectorAll('.twistOnIt').forEach((twistOnIt) => {
      twistOnIt.style.backgroundImage = `url(${twistOnItImg})`;
    });

    document.querySelector(
      '#topBar'
    ).style.backgroundImage = `url(${TopStrip})`;
    document.querySelector(
      '.scannerArea'
    ).style.backgroundImage = `url(${scannerArea})`;
    document.querySelector(
      '.mobileIcon'
    ).style.backgroundImage = `url(${mobileSprite})`;
    document.querySelector(
      '.tapIcon'
    ).style.backgroundImage = `url(${handsprite})`;
    document.querySelector(
      '.timeIcon'
    ).style.backgroundImage = `url(${timeSprite})`;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    Global.playerIndex = parseInt(urlParams.get('playerIndex') || 1);
    Global.collectableType = urlParams.get('collectableType') || null;
    Global.isMultiplayer = Global.playerIndex === 2;

    if (urlParams.get('gameID')) {
      Global.gameID = urlParams.get('gameID') || 0;
      Global.U_ID = Global.gameID;
      Global.gameTry = parseInt(urlParams.get('gameTry') || 0);
      Global.roomID = urlParams.get('roomID') || null;
      Global.gameKey = urlParams.get('gameKey') || null;
    }

    this.environmentMap = null;
    this.sizes = {
      width: window.innerWidth,
      height: window.innerHeight,
    };
    this.titleShown = true;
    this.titleIndex = 0;
    this.lightIndex = 0;
    this.phoneIndex = 0;
    this.tapIndex = 0;
    this.timeIndex = 0;
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('LOADER_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAME_EVENTS', this.onGameEvents.bind(this));
    this.events.addEventListener(
      'GAMESCENE_EVENTS',
      this.onGameEvents.bind(this)
    );
    this.events.addEventListener('SOUND_EVENTS', this.onSoundEvents.bind(this));
    this.events.addEventListener(
      'ANIMATION_EVENTS',
      this.onAnimEvents.bind(this)
    );
    Global.serverObj = new Server();
    if (parseInt(Global.playerIndex) === 1) {
      Global.U_ID = localStorage.getItem('U_ID') || '';
      Global.gameID = Global.U_ID;
      Global.click_id = localStorage.getItem('click_id');
      Global.gameKey = localStorage.getItem('gameKey');
      Global.name = localStorage.getItem('name');
      Global.email = localStorage.getItem('email');
      Global.mobile = localStorage.getItem('mobile');
      Global.country = localStorage.getItem('country');
      Global.pack = localStorage.getItem('pack');
      Global.gameTry = parseInt(localStorage.getItem('gameTry') || 0);
      if (
        Global.U_ID === '' ||
        typeof Global.U_ID === 'undefined' ||
        Global.U_ID == null ||
        Global.U_ID === 0 ||
        Global.gameKey === '' ||
        typeof Global.gameKey === 'undefined' ||
        Global.gameKey == null ||
        Global.gameKey === 0 ||
        Global.name === '' ||
        typeof Global.name === 'undefined' ||
        Global.name == null ||
        Global.name === 0 ||
        Global.country === '' ||
        typeof Global.country === 'undefined' ||
        Global.country == null ||
        Global.country === 0 ||
        Global.email === '' ||
        typeof Global.email === 'undefined' ||
        Global.email == null ||
        Global.email === 0 ||
        Global.email === 'undefined' ||
        Global.pack === '' ||
        typeof Global.pack === 'undefined' ||
        Global.pack == null ||
        Global.pack === 0 ||
        Global.mobile === '' ||
        typeof Global.mobile === 'undefined' ||
        Global.mobile == null ||
        Global.mobile === 0 ||
        Global.click_id === '' ||
        typeof Global.click_id === 'undefined' ||
        Global.click_id == null ||
        Global.click_id === 0
      ) {
        localStorage.clear();
        this.createUser();
      } else {
        Global.serverObj.send(
          `${Global.BASE_URL}webservice.php`,
          (response) => {
            try {
              response = JSON.parse(response);
              Global.gameTry = parseInt(response.gameTry || 0);
              localStorage.setItem('gameTry', Global.gameTry);
            } catch (err) {}
          },
          null,
          {
            saveType: 'getGameTry',
          },
          'POST',
          null,
          false
        );

        Global.loginStatus = true;
      }
    } else {
      const dataToSent = {
        gameTry: Global.gameTry,
        saveType: 'playerScan',
      };
      Global.serverObj.send(
        `${Global.BASE_URL}webservice.php`,
        (response) => {
          response = JSON.parse(response);
        },
        null,
        dataToSent,
        'POST',
        null,
        false
      );
    }
    initMenu();
    showMenu();
    initLang();
    gtag('event', 'conversion', {
      allow_custom_scripts: true,
      u1: 'https://www.oreostayplayful.com/',
      u21: '',
      u5: '',
      send_to: 'DC-9227341/oreo-003/inter0+standard',
    });
    document.getElementById('nscript').innerHTML =
      '<img src="https://ad.doubleclick.net/ddm/activity/src=9227341;type=oreo-003;cat=inter0;u1=https://www.oreostayplayful.com/;u5=[];u21=[];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=1?" width="1" height="1" alt=""/>';
    Global.events = this.events;
    this.stoppedAt = 0;
    Global.isGameActive = false;
    this.startTime = -1;
    this.elapsedTime = 0;
    this.currentTime = 0;
    this.levelCompleted = true;
    this.moveThreshold = 10;
    this.maxTime = 30;
    this.mouseDown = false;
    this.mouse = {
      x: 0,
      y: 0,
    };
    this.mouseDownPosition = {
      x: 0,
      y: 0,
    };

    this.raycaster = new THREE.Raycaster();
    this.canvas = document.querySelector('canvas#webgl');
    this.clock = new THREE.Clock();
    // this.gui = new GUI();
    // this.gui.init();
    this.camera = new Camera(
      60,
      this.sizes.width / this.sizes.height,
      0.025,
      20
    );
    this.camera.init();
    this.add(this.camera);

    this.controls = new Control(this.camera, this.canvas);
    this.controls.init();

    this.renderer = new THREE.WebGLRenderer({
      canvas: this.canvas,
      antialias: true,
      precision: 'highp',
      powerPreference: 'high-performance',
    });
    this.renderer.physicallyCorrectLights = true;
    this.renderer.toneMappingExposure = 1;
    this.renderer.toneMapping = THREE.LinearToneMapping;
    this.renderer.gammaOutput = true;
    this.renderer.outputColorSpace = THREE.SRGBColorSpace;

    this.renderer.gammaFactor = 2.2;
    this.renderer.setClearColor(0x000000, 0);
    this.renderer.useLegacyLights = false;
    this.renderer.setSize(this.sizes.width * 1, this.sizes.height * 1);
    this.renderer.setPixelRatio(
      Math.min(Math.max(2, window.devicePixelRatio), isMobile ? 1.5 : 2.5)
    );

    this.room = new Room(this, this.renderer, this.camera);
    this.room.init();

    this.home = new Home();
    this.home.init();

    this.langSelection = new LangSelection();
    this.langSelection.init();

    this.instruction = new Instruction();
    this.instruction.init();

    this.signup = new SignUp();
    this.signup.init();

    this.signin = new SignIn();
    this.signin.init();

    this.Score = new Score();
    this.Score.init();

    this.playToWin = new PlayToWin();
    this.playToWin.init();

    this.error = new Error();
    this.error.init();

    this.signupSignin = new SignupSignin();
    this.signupSignin.init();

    this.tapToTwist = new TapToTwist();
    this.tapToTwist.init();

    this.selectFlavour = new SelectFlavour();
    this.selectFlavour.init();

    this.select = new Select();
    this.select.init();

    this.signUpToPlay = new SignUpToPlay();
    this.signUpToPlay.init();

    this.qrScanner = new QRScanner();
    this.qrScanner.init();

    this.gameInst = new GameInst();
    this.gameInst.init();
    this.playerName = new PlayerName();
    this.playerName.init();

    this.header = new Header();
    this.header.init();

    this.result = new Result();
    this.result.init();

    this.leaderboard = new LeaderBoard(this, this.camera, this.renderer);
    this.leaderboard.init();

    this.sideSelection = new Selection(this, this.camera, this.renderer);
    this.sideSelection.init();

    this.tick();
    this.registerSceneClicks();

    this.assetLoader = new AssetLoader(this);
    this.assetLoader.init();
    this.assetLoader.load();
  }
  createUser() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const source = urlParams.get('utm_source');
    $.ajax({
      url: 'https://newsfeedsmartapp.com/OreoNewFlavour/api/createUser.php',
      method: 'POST',
      dataType: 'json',
      data: {
        saveType: 'create',
        source,
      },
      success(responseData) {
        if (responseData.code === 200) {
          Global.U_ID = responseData.uid;

          Global.gameID = Global.U_ID;
          Global.click_id = responseData.uid;
          Global.gameKey = responseData.game_key;
          document.querySelector('.container').style.display = 'flex';
          // Global.loginStatus = true;
          // Global.U_ID = 309945013;
          // Global.gameKey = 'AAAA4b1hmVvAAAAA';
        }
      },
      error(jqXHR, textStatus, errorThrown) {
        //  localStorage.clear()
        //  window.location.href = '/';
      },
    });
  }
  onMouseDown(event) {
    this.mouseDown = true;

    // Capture initial mouse position
    this.mouseDownPosition.x = event.clientX;
    this.mouseDownPosition.y = event.clientY;
  }
  onMouseUp(event) {
    if (this.mouseDown) {
      // Calculate mouse movement
      const moveX = event.clientX - this.mouseDownPosition.x;
      const moveY = event.clientY - this.mouseDownPosition.y;
      const distance = Math.sqrt(moveX * moveX + moveY * moveY);

      if (distance < this.moveThreshold) {
        // Handle click
        this.handleClick(event);
      }

      // Reset mouseDown flag
      this.mouseDown = false;
    }
  }
  onMouseMove(event) {
    if (this.mouseDown) {
      // Optionally handle mouse movement while dragging
    }
  }
  getTopLevelParent(object) {
    let current = object;
    while (
      current.parent &&
      current.parent.type !== 'Scene' &&
      (!current.parent.userData ||
        (current.parent.userData &&
          current.parent.userData.itemType !== 'leader_group'))
    ) {
      current = current.parent;
    }
    return current;
  }
  handleClick(event) {
    if (!this.clock.running) return false;

    if (event.type === 'touchstart') {
      this.mouse.x = (event.touches[0].clientX / window.innerWidth) * 2 - 1;
      this.mouse.y = -(event.touches[0].clientY / window.innerHeight) * 2 + 1;
    } else {
      this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
      this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
    }

    // this.raycaster.ray.origin.copy(this.camera.position);
    // this.raycaster.ray.direction
    //   .set(this.mouse.x, this.mouse.y, 1)
    //   .unproject(this.camera)
    //   .sub(this.camera.position)
    //   .normalize();
    this.raycaster.setFromCamera(this.mouse, this.camera);
    const intersects = this.raycaster.intersectObjects(this.children, true);

    if (intersects.length > 0) {
      let itemFound = false;
      intersects.forEach((intersect) => {
        if (!itemFound) {
          const { object } = intersect;
          const item = this.getTopLevelParent(object);
          if (
            item.userData &&
            item.userData.itemType &&
            item.userData.itemType === 'voting_cookie'
          ) {
            itemFound = true;

            this.events.dispatchEvent({
              type: 'GAME_EVENTS',
              message: {
                event_type: 'voting',
                data: {
                  voteFor: item.userData.voteFor,
                },
              },
            });
          }
          if (
            item.userData &&
            item.userData.itemType &&
            item.userData.itemType === 'team_select_cookie'
          ) {
            itemFound = true;
            this.events.dispatchEvent({
              type: 'GAME_EVENTS',
              message: {
                event_type: 'select_team',
                data: {
                  teamKey: item.userData.teamKey,
                },
              },
            });
          }
          if (
            item.userData &&
            item.userData.itemType &&
            item.userData.itemType === 'collectable' &&
            Global.isGameActive
          ) {
            itemFound = true;
            this.events.dispatchEvent({
              type: 'GAME_EVENTS',
              message: {
                event_type: 'collectable_found',
                data: {
                  collectable: item,
                },
              },
            });
          }
        }
      });
    }
  }
  registerSceneClicks() {
    window.addEventListener('touchstart', this.handleClick.bind(this), false); // For touch
    window.addEventListener('mousedown', this.handleClick.bind(this), false); // For touch
  }
  onLevelSelected() {
    setTimeout(() => {
      this.startGame();
    }, 200);
    setTimeout(() => {
      this.startTime = this.clock.getElapsedTime();
      this.levelCompleted = false;
    }, 1000);
  }
  startGame() {
    Global.isGameActive = true;
    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'start_game',
        data: {},
      },
    });
  }
  handleVisibilityChange() {
    if (document.visibilityState === 'visible') {
      Global.isWindowActive = true;
      if (Global.ambient1Active) {
        this.events.dispatchEvent({
          type: 'SOUND_EVENTS',
          message: {
            event_type: 'ambient',
            data: {},
          },
        });
      }

      // Resume operations or update the UI
    } else {
      Global.isWindowActive = false;

      this.events.dispatchEvent({
        type: 'SOUND_EVENTS',
        message: {
          event_type: 'ambient_off',
          data: {
            byGame: false,
          },
        },
      });
    }
  }
  onSoundEvents(data) {
    switch (data.message.event_type) {
      case 'ambient':
        Global.ambient1Active = true;
        Global.soundEnabled && document.querySelector('#BGSound').play();
        break;
      case 'difficulty':
        Global.ambient2Active = true;
        Global.soundEnabled &&
          document.querySelector('#difficultySound').play();
        break;
      case 'ambient_off':
        if (data.message.data.byGame) {
          Global.ambient1Active = false;
        }
        document.querySelector('#BGSound').pause();
        break;
      case 'difficulty_off':
        if (data.message.data.byGame) {
          Global.ambient2Active = false;
        }
        document.querySelector('#difficultySound').pause();
        break;
      case 'tap':
        Global.isWindowActive &&
          Global.soundEnabled &&
          (document.querySelector('#TapSound').pause(),
          (document.querySelector('#TapSound').currentTime = 0),
          setTimeout(() => {
            document.querySelector('#TapSound').playbackRate = 2;
            document.querySelector('#TapSound').play();
          }, 0));
        break;
    }
  }
  showLeader() {
    setTimeout(() => {
      this.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'show_leader',
          data: {
            offset: 0.5,
          },
        },
      });
    }, 10);
  }
  onEvents(data) {
    switch (data.message.event_type) {
      case 'load_complete':
        setTimeout(() => {
          document.querySelector('.loading_scr').classList.add('disabled');
        }, 250);
        if (Global.playerIndex === 1) {
          this.showScreen('LangSelection');

          // Global.isMultiplayer = true;
          // this.events.dispatchEvent({
          //   type: 'LOADER_EVENTS',
          //   message: {
          //     event_type: 'switch_page',
          //     data: {
          //       screenKey: 'show_leader',
          //       lang: Global.lang,
          //     },
          //   },
          // });
        } else {
          this.showScreen('PlayerName');
        }
        break;
      case 'switch_page':
        this.showScreen(data.message.data.screenKey);
        break;
    }
  }
  onAnimEvents(data) {
    switch (data.message.event_type) {
      case 'twistAnimation':
        this.twistAnimation(data.message.data.selector);
        break;
      case 'buttonAnimation':
        this.buttonAnimation(data.message.data.selector);
        break;
      default:
        break;
    }
  }
  onGameEvents(data) {
    switch (data.message.event_type) {
      case 'replay_game':
        this.replayGame();
        break;
      case 'start_game':
        document.querySelectorAll('.screen').forEach((screen) => {
          screen.classList.remove('active');
        });
        break;
      case 'level_complete':
        this.stopGame();
        break;
      case 'level_selected':
        this.onLevelSelected(data.message.data.level);
        break;
      case 'remove_rempod_hint':
        if (data.message.data.continueGame && this.stoppedAt === 0) {
          this.clock.start();
          Global.clockStopped = false;
          this.stoppedAt = 10;
          this.startTime = 0;
          this.events.dispatchEvent({
            type: 'GAMESCENE_EVENTS',
            message: {
              event_type: 'enable_control',
              data: {},
            },
          });
        }
        break;
      case 'update_language':
        this.updateLanguage();
        break;
      default:
        break;
    }
  }
  updateLanguage() {
    document.querySelectorAll('.twistOnIt').forEach((el) => {
      el.style.backgroundImage = `url("${
        Global.lang === 'ENG' ? SpriteAnimENG : SpriteAnimARB
      }")`;
    });
    document.querySelector('.join').querySelector('img').src =
      Global.lang == 'ENG' ? joinENG : joinARB;
    document.querySelector('#signupsigninImg').src =
      Global.lang == 'ENG' ? signupsigninENG : signupsigninARB;
    document.querySelector('#metBefore').src =
      Global.lang == 'ENG' ? metBeforeENG : metBeforeARB;
    document.querySelector('#firstTime').src =
      Global.lang == 'ENG' ? firstTimeENG : firstTimeARB;
    document.querySelector('#pickYourSide').src =
      Global.lang == 'ENG' ? PickSideENG : PickSideARB;
    document.querySelector('#howToPlayImg').src =
      Global.lang == 'ENG' ? howToPlayENG : howToPlayARB;
    document.querySelector('#youHaveChoosen').src =
      Global.lang == 'ENG' ? youHaveChoosenENG : youHaveChoosenARB;
    document.querySelector('#scannerTitleImg').src =
      Global.lang == 'ENG' ? scannerTitleImgENG : scannerTitleImgARB;
    document.querySelector('#justSoWeKnowImg').src =
      Global.lang == 'ENG' ? justSoWeKnowImgENG : justSoWeKnowImgARB;
  }
  buttonAnimation(select) {
    gsap.set(select, {
      opacity: 0,
      y: 50,
    });

    gsap.to(select, {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: 'power3.out',
    });
  }
  twistAnimation(cls) {
    let k = 0;
    const percentage = 100 / 43;
    const int = setInterval(() => {
      document.querySelector(cls).style.backgroundPosition = `50% ${
        k * percentage
      }%`;
      k++;
      if (k === 44) {
        clearInterval(int);
      }
    }, 20);
  }
  addOrRemoveSparkle(add, parentSelector) {
    document
      .querySelector(parentSelector)
      .querySelectorAll('.sparkle')
      .forEach((sparkle) => {
        if (add) {
          sparkle.classList.add('active');
        } else {
          sparkle.classList.remove('active');
        }
      });
  }
  openRoom() {
    this.showScreen('Home');
  }
  disableAllPages(screenKey) {
    document.querySelectorAll('.screen').forEach((screen) => {
      screen.classList.remove('active');
    });
    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'show_screen',
        data: {
          screenKey,
        },
      },
    });
  }
  showScreen(screenKey) {
    this.disableAllPages(screenKey);
  }
  hideScreen(screenKey) {
    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'hide_screen',
        data: {
          screenKey,
        },
      },
    });
  }
  stopGame() {
    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'save_score',
        data: {},
      },
    });
    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'stop_game',
        data: {},
      },
    });

    this.levelCompleted = true;

    this.showScreen('Score');
    Global.isGameActive = false;
    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'remove_all_from_room',
        data: {},
      },
    });
    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'remove_control',
        data: {},
      },
    });
  }
  onResize() {
    this.sizes.width = window.innerWidth;
    this.sizes.height = window.innerHeight;
    this.events.dispatchEvent({
      type: 'CAMERA_EVENTS',
      message: {
        event_type: 'resize',
        data: {
          aspect: this.sizes.width / this.sizes.height,
          sizes: this.sizes,
        },
      },
    });
    this.renderer.setSize(this.sizes.width, this.sizes.height);
    this.renderer.setPixelRatio(
      Math.min(Math.max(2, window.devicePixelRatio), isMobile ? 1.5 : 2.5)
    );
  }

  tick(now) {
    this.currentTime = this.clock.getElapsedTime() * 1 + this.stoppedAt;

    if (this.startTime >= 0 && !this.levelCompleted) {
      this.elapsedTime = Math.floor(this.currentTime - this.startTime);
      this.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'time_tick',
          data: {
            time: this.maxTime - this.elapsedTime,
          },
        },
      });

      if (this.maxTime - this.elapsedTime <= 0 && !this.levelCompleted) {
        this.stopGame();
      }
    }
    this.renderer.render(this, this.camera);
    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'update',
        data: {
          elapsedTime: this.currentTime,
        },
      },
    });

    window.requestAnimationFrame(this.tick.bind(this));
  }
}
Global.baseURL = `${getBasePath()}/`;

if (isMobile) {
  initColyseus();
  const game = new Game();
  game.init();
  document.querySelector('.loading_scr').classList.add('active');
} else {
  const { baseURL } = Global;
  const player2URL = `${baseURL}?utm_source=DesktopQR`;

  const canvas = document.querySelector('.desktop_scr .scan_qr');
  QRCode.toCanvas(canvas, player2URL, (error) => {
    if (error) console.error(error);
  });
  document.querySelector('.desktop_scr').classList.add('active');
}
function getBasePath() {
  const { origin, pathname } = window.location;

  const pathParts = pathname.split('/').filter(Boolean);

  // If there are no subfolders, return origin only
  if (pathParts.length === 0) return origin;

  // Return origin + first subfolder (without trailing slash)
  return `${origin}/${pathParts[0]}`;
}
